import './index.less'

import promiseFinally from 'promise.prototype.finally';

import React from 'react'
import {render} from 'react-dom'
import { Provider } from 'mobx-react';
import {LocaleProvider} from 'antd';
import Ru from 'antd/lib/locale-provider/ru_RU';
import moment from 'moment';
moment.locale('ru');

import {HashRouter, BrowserRouter} from 'react-router-dom';

import App from './app'
import {createStores} from './stores';

const stores = createStores();

window._____APP_STATE_____ = stores;

promiseFinally.shim();

render((
  <Provider {...stores}>
    <LocaleProvider locale={Ru}>
      <BrowserRouter>
        <App/>
      </BrowserRouter>
    </LocaleProvider>
  </Provider>
), document.querySelector('#app'));



// WEBPACK FOOTER //
// ./src/index.js